import anime from '@/assets/libs/anime';
import { inApp } from '@/scripts/utils';


export function appButtonInit(el) {
  const ctx = el;
  const contetButtons = [...ctx.querySelectorAll('.button span')];
  const svgsTop = [...ctx.querySelectorAll('.button__svg-top')];
  const svgsBg = [...ctx.querySelectorAll('.button__svg-bg')];

  anime.set(contetButtons, { opacity: 0 });
  anime.set(svgsTop, { scale: 0, transformOrigin: '50% 50% 0' });
  anime.set(svgsBg, { scale: 0, transformOrigin: '50% 50% 0' });
}

export function appButtonAnim(el, delay = 0) {
  const ctx = el;
  const contetButtons = [...ctx.querySelectorAll('.button span')];
  const svgsTop = [...ctx.querySelectorAll('.button__svg-top')];
  const svgsBg = [...ctx.querySelectorAll('.button__svg-bg')];
  const tl = anime.timeline({
    easing: 'cubicBezier(.5,0,0,1)',
    duration: inApp() ? 1400 : 1800,
  });

  tl
    .add({
      targets: svgsTop,
      scale: 1,
      transformOrigin: '50% 50% 0',
      delay: anime.stagger(350, { start: delay }),
    }, 0)
    .add({
      targets: contetButtons,
      opacity: 1,
      delay: anime.stagger(350, { start: delay }),
      duration: 500,
    }, 700)
    .add({
      targets: svgsBg,
      scale: 1,
      transformOrigin: '50% 50% 0',
      delay: anime.stagger(350, { start: delay }),
      duration: inApp() ? 1100 : 1500,
    }, 250);

  return tl;
}

export function appButtonOut(el, delay = 0) {
  const ctx = el;
  const contetButtons = [...ctx.querySelectorAll('.button span')];
  const svgsTop = [...ctx.querySelectorAll('.button__svg-top')];
  const svgsBg = [...ctx.querySelectorAll('.button__svg-bg')];
  const tl = anime.timeline({
    easing: 'cubicBezier(.5,0,0,1)',
    duration: inApp() ? 1000 : 1200,
  });

  tl
    .add({
      targets: svgsBg,
      scale: 0,
      transformOrigin: '50% 50% 0',
      delay: anime.stagger(350, { start: delay }),
    }, 0)
    .add({
      targets: contetButtons,
      opacity: 0,
      delay: anime.stagger(350, { start: delay }),
      duration: 500,
    }, 200)
    .add({
      targets: svgsTop,
      scale: 0,
      transformOrigin: '50% 50% 0',
      delay: anime.stagger(350, { start: delay }),
    }, 200);

  return tl;
}
